module.exports = "/assets/data/c51c02f6b1c77a9256f6a1f552148087-MK10.data.json";